module.exports = __webpack_public_path__ + "static/media/asurion-protect-it-desktop-big.5e0050f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/asurion-protect-it-desktop-big.jpg
// module id = 1386
// module chunks = 0